import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, useContext, useRouter } from '@nuxtjs/composition-api';
import BravadoCheckboxV3 from '@/components/common/BravadoCheckboxV3/BravadoCheckboxV3.vue';
import WarRoomCommissionEarnBannerCard from '@/components/partials/war-room/WarRoomCommissionEarnBanner/WarRoomCommissionEarnBannerCard.vue';
import WarRoomCommissionEarnBannerPoint from '@/components/partials/war-room/WarRoomCommissionEarnBanner/WarRoomCommissionEarnBannerPoint.vue';
import QuestionIcon from '@/assets/svg/question.vue.svg';
import { commissionItemTypes, FAQPostUri } from '@/components/partials/war-room/WarRoomCommissionEarnBanner/constants';

type CommissionChecklistNames = (typeof commissionItemTypes)[keyof typeof commissionItemTypes];

interface CommissionChecklistItem {
  type: string;
  price: number;
  state: 'new' | 'done';
  isComplete?: boolean;
}

type WarRoomCommissionEarnBannerChecklistProps = {
  items: CommissionChecklistItem[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomCommissionEarnBannerChecklist',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
  items: CommissionChecklistItem[];
};


const { $analytics } = useContext();
const router = useRouter();

const ALLOWED_TYPES = [
  commissionItemTypes.SIGN_UP,
  commissionItemTypes.UPLOAD_PROFILE_PICTURE,
  commissionItemTypes.READ_FAQ,
  commissionItemTypes.UPVOTE_POST_OR_COMMENT,
  commissionItemTypes.CREATE_COMMENT,
  commissionItemTypes.FILL_PROFILE,
  commissionItemTypes.DOWNLOAD_MOBILE_APP,
];

onMounted(() => {
  $analytics?.logEvent('war-room__all-posts__checklist__shown');
});

const visibleItems = computed(() => {
  const itemsMap = props.items.reduce(
    (items, item) => ({ ...items, [item.type]: { ...item, isComplete: item.state === 'done' } }),
    {},
  ) as Record<CommissionChecklistNames, CommissionChecklistItem>;

  return ALLOWED_TYPES.reduce(
    (items: CommissionChecklistItem[], type: CommissionChecklistNames) =>
      itemsMap[type] ? [...items, itemsMap[type]] : items,
    [],
  );
});

function openFAQ() {
  router.push(FAQPostUri);
}

function handleItemClick(type: string) {
  $analytics?.logEvent('war-room__all-posts__checklist-action__click', { action: type });
}

async function onUploadAvatarClick() {
  handleItemClick(commissionItemTypes.UPLOAD_PROFILE_PICTURE);

  await router.push('/war-room/profile/edit');
}

return { __sfc: true,props, $analytics, router, ALLOWED_TYPES, visibleItems, openFAQ, handleItemClick, onUploadAvatarClick, BravadoCheckboxV3, WarRoomCommissionEarnBannerCard, WarRoomCommissionEarnBannerPoint, QuestionIcon, commissionItemTypes }
}

})